import { gql } from '@lcs/shared/api';

export const getFaxesQuery = gql`
   query GetFaxes($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      faxesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            faxId
            extensionId
            faxTypeId
            faxStatusName
            from
            to
            processedTime
            createDate
            updateDate
            exceptionMessage
            sipCallId
            associatedProviderId
            associatedIp
            podIp
            podName
            attachmentsConnection {
               items {
                  faxStatusId
                  file {
                     fileToken
                     fileName
                     displayName
                     type
                  }
               }
            }
         }
      }
   }
`;
